/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteActorList.defs.js'
export * as $defs from './muteActorList.defs.js'
